import axiosInstance from "../variables/api/axiosInstance";

// Types de documents (doivent matcher l'enum backend TypeDocumentSignataire).
export const TYPE_DOC_SIGNATAIRE = {
    ORDRE_DEPENSE: "ORDRE_DEPENSE",
    FICHE_DEMANDE_REGLEMENT: "FICHE_DEMANDE_REGLEMENT",
    QUITTANCE_INDEMNITE: "QUITTANCE_INDEMNITE",
};

// Config à éditer (organisme courant) pour un type de document.
export const getSignatairesConfig = (typeDocument) =>
    axiosInstance.get(`/api/signataire-document/config`, { params: { typeDocument } });

// Remplace la config de l'organisme courant pour un type de document.
export const saveSignatairesConfig = (typeDocument, lignes) =>
    axiosInstance.put(`/api/signataire-document/config`, lignes, { params: { typeDocument } });

// Signataires RÉSOLUS (titre + nom + visible) pour un document donné.
export const getSignatairesResolus = (organisme, typeDocument, decaissementCodeId) =>
    axiosInstance.get(`/api/signataire-document/resolus`, {
        params: { organisme, typeDocument, ...(decaissementCodeId ? { decaissementCodeId } : {}) },
    });

// Override d'affichage des signataires pour UN règlement (à l'impression).
export const setSignatairesOverride = (decaissementCodeId, override) =>
    axiosInstance.put(`/api/signataire-document/override/${decaissementCodeId}`, override || {});
